import { configureStore } from "@reduxjs/toolkit";
import { PersistConfig, persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";

import rootReducer from "./reducer";
import rootSaga from "./saga";
import { RootState } from "./types";

const persistConfig: PersistConfig<any> = {
  blacklist: ["app"],
  key: "root",
  stateReconciler: autoMergeLevel2,
  storage,
};

/**
 * Logs all actions and states after they are dispatched.
 */
const loggerMiddleware = (store) => (next) => (action) => {
  if (process.env.REACT_APP_STAGE === "production") return;

  console.group(action.type);
  console.info("dispatching", action);
  let result = next(action);
  console.log("next state", store.getState());
  console.groupEnd();
  return result;
};

const sagaMiddleware = createSagaMiddleware();
const persistRootReducer = persistReducer<RootState>(persistConfig, rootReducer);

export function createStore() {
  let middlewares = [];

  if (process.env.NODE_ENV !== "production") {
    middlewares = [loggerMiddleware, sagaMiddleware];
  } else {
    middlewares = [sagaMiddleware];
  }

  const store = configureStore({
    middleware: middlewares,
    reducer: persistRootReducer,
  });

  return store;
}

const store = createStore();
sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);

export default store;
